var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.57382C3.70698 6.76065 4.85714 4.57436 6.57143 6.28811C8.04427 7.76049 4.87732 15.5606 3.95601 17.7286C3.90646 17.8452 4.05991 17.9425 4.14949 17.8529L12.6341 9.36831C12.7096 9.29275 12.8381 9.35333 12.8281 9.45973C12.548 12.443 12.3303 13.4796 14 14.2881C15.7271 15.1243 18.5714 13.1458 22 11.431",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default SvgSign;